<template>
  <div>
    <Modal v-model="uploadNetworkImagesModal" width="550" :title="$t('key1001298')" @on-visible-change="uploadNetworkImagesChange">
      <Form ref="uploadNetworkImagesForm" :model="uploadNetworkImagesForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem" style="width: 90%;">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001299')" prop="uploadAddress">
              <Input v-model="uploadNetworkImagesForm.uploadAddress" clearable placeholder="https://"></Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="uploadNetworkImagesModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" :disabled="!uploadNetworkImagesForm.uploadAddress" @click="uploadNetworkImagesBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--裁剪图片的弹窗-->
    <kjnovaClipperModal :multiple="false" ref="kjnovaClipper" @updateUploadImg="updateUploadImg"></kjnovaClipperModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import kjnovaClipperModal from "@/components/common/kjnovaClipperModal.vue";
import {handleUploadImageAddress} from "@/utils/common";

export default {
  name: 'uploadNetworkImagesModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      uploadNetworkImagesModal: false,
      uploadNetworkImagesForm: {
        uploadAddress: ''
      },
      ruleValidate: {
        uploadAddress: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001295'), trigger: 'blur'},
          {pattern: v.$regular.linkAddress, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001296'), trigger: 'blur'},
        ],
      }
    };
  },
  methods: {
    // 确定
    uploadNetworkImagesBtn() {
      let v = this;
      let url = v.systemTalg ? '?basePath=yms-supplier-service' : '?basePath=yms-core-service';
      let query = [v.uploadNetworkImagesForm.uploadAddress];
      v.$refs['uploadNetworkImagesForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_uploadNetworkFiles + url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              if (data.length > 0) {
                let tempUrl = data[0];
                let link = handleUploadImageAddress(tempUrl);
                v.$refs['kjnovaClipper'].initKjnovaClipperData(link);
              }
              v.uploadNetworkImagesModal = false;
            } else {
              v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001297'));
              return false;
            }
          });
        }
      });
    },
    // 监听弹窗
    uploadNetworkImagesChange(value) {
      if (!value) {
        this.uploadNetworkImagesForm.uploadAddress = '';
      }
    },
    // 裁剪图片
    updateUploadImg(data) {
      this.$emit('updateUploadImg', data);
    }
  },
  components: {
    kjnovaClipperModal
  },
};
</script>

<style scoped>

</style>
